(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root && root.document) {
    api.init(root.document);
  }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  function optionsMatch(variantOptions, selectedOptions) {
    if (!Array.isArray(variantOptions) || variantOptions.length !== selectedOptions.length) {
      return false;
    }

    return variantOptions.every(function (option, index) {
      return String(option) === String(selectedOptions[index]);
    });
  }

  function addVariantParameter(productUrl, variantId) {
    var hashIndex = productUrl.indexOf('#');
    var hash = hashIndex === -1 ? '' : productUrl.slice(hashIndex);
    var urlWithoutHash = hashIndex === -1 ? productUrl : productUrl.slice(0, hashIndex);
    var queryIndex = urlWithoutHash.indexOf('?');
    var pathname = queryIndex === -1 ? urlWithoutHash : urlWithoutHash.slice(0, queryIndex);
    var query = queryIndex === -1 ? '' : urlWithoutHash.slice(queryIndex + 1);
    var params = new URLSearchParams(query);

    params.set('variant', String(variantId));
    return pathname + '?' + params.toString() + hash;
  }

  function castVariantUrl(productUrl, variants, selectedOptions) {
    var match = variants.find(function (variant) {
      return optionsMatch(variant.options, selectedOptions);
    });

    return match ? addVariantParameter(productUrl, match.id) : productUrl;
  }

  function readVariants(selector) {
    var data = selector.querySelector('[data-sock-style-variants]');

    if (!data) return [];

    try {
      return JSON.parse(data.textContent);
    } catch (error) {
      return [];
    }
  }

  function selectedOptions(optionsRoot) {
    return Array.prototype.map.call(
      optionsRoot.querySelectorAll('select[name^="option"]'),
      function (select) { return select.value; }
    );
  }

  function sync(selector) {
    var link = selector.querySelector('[data-sock-style-link]');
    var optionsRoot = selector.closest('.product-detail__form__options');

    if (!link || !optionsRoot) return;

    var productUrl = link.getAttribute('data-linked-product-url');
    var variants = readVariants(selector);

    if (!productUrl || !variants.length) return;

    link.setAttribute('href', castVariantUrl(productUrl, variants, selectedOptions(optionsRoot)));
  }

  function bind(selector) {
    if (selector.getAttribute('data-sock-style-bound') === 'true') return;

    var link = selector.querySelector('[data-sock-style-link]');
    var optionsRoot = selector.closest('.product-detail__form__options');

    if (!link || !optionsRoot) return;

    selector.setAttribute('data-sock-style-bound', 'true');
    optionsRoot.addEventListener('change', function (event) {
      if (event.target && event.target.matches('select[name^="option"]')) {
        sync(selector);
      }
    });
    link.addEventListener('click', function () {
      sync(selector);
    });
    sync(selector);
  }

  function init(scope) {
    var selectors = scope.querySelectorAll('[data-sock-style-selector]');
    Array.prototype.forEach.call(selectors, bind);
  }

  if (typeof document !== 'undefined') {
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }

  return {
    castVariantUrl: castVariantUrl,
    init: init
  };
});
